module.exports = __webpack_public_path__ + "static/media/fnb.8c2305f4.png";